import {withClassNames} from 'quickstart/theme'
import S from './styles.module.css'

export const Divider = withClassNames(S.divider)('hr')
